import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { TextcontentModel } from './textcontent.model';

export class TextblockModel extends BaseModel implements Deserializable {

  // columns
  identifier: string;
  type: string;
  description: string = null;

  // relations
  contents: Array<TextcontentModel> = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    // contents
    let contents = [];
    if (this.contents !== null && this.contents !== undefined) {
      this.contents.forEach((content: TextcontentModel) => {
        contents.push(new TextcontentModel().deserialize(content));
      });
    }
    this.contents = contents;
    return this;
  }

  public get language_list(): string {
    return this.contents.map((content: TextcontentModel) => {
      return content?.language?.key;
    }).join(' | ');
  }

}
